import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { Box } from "@mui/system";
import CarrierNetworkLeadAction from "./CarrierNetworkLeadAction/CarrierNetworkLeadAction";
import CarrierNetworkRelationshipAction from "./CarrierNetworkRelationshipAction/CarrierNetworkRelationshipAction";
import CarrierNetworkOpenAction from "./CarrierNetworkOpenAction/CarrierNetworkOpenAction";
import SecurityCheck from "../../../../SecurityCheck/SecurityCheck";
import { SecurityService } from "../../../../../services/SecurityService";
import { AlertContext } from "../../../../Dashboard/Dashboard";

export default function CarrierNetworkActions({
  networkStatus,
  statusIds,
  statusLabels,
  canUpdate,
  canRemove,
  setIsLoading,
  getNetworkStatus,
  carrier,
  activeUser,
  networkUserId,
  carrierNetworkId,
  getCarrier,
  setIsUpdating,
  canAddAsLead,
  networkUserName
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [canAddManually, setCanAddManually] = useState(false);
  const [userDefault, setUserDefault] = useState("");
  const manualUpdateRoles = ["Super Administrator", "Administrator", "Carrier Rep Manager"];

  useEffect(() => {
    if (activeUser?.role) {
      setCanAddManually(manualUpdateRoles.includes(activeUser.role.roleName));
    }
  }, [activeUser]);

  useEffect(() => {    
    if (networkUserId === null || !canAddManually) {
      setUserDefault("");
    } else {
      SecurityService.GetUsers(instance).then(res => {
        setUserDefault(res.find(e => e.userIdMcld === networkUserId));
      }).catch(error => {      
        console.error(error);
        warning(error);
      });
    }
  }, [networkUserId, canAddManually]);

  const getActionsComponent = () => {
    if (networkStatus === statusIds.lead) {
      return <CarrierNetworkLeadAction
        networkUserName={networkUserName}
        networkUserId={networkUserId}
        activeUser={activeUser}
        networkStatus={networkStatus}
        getNetworkStatus={getNetworkStatus}
        carrier={carrier}
        getCarrier={getCarrier}
        canUpdate={canUpdate}
        canRemove={canRemove}
        statusLabels={statusLabels}
        carrierNetworkId={carrierNetworkId}
        setIsLoading={setIsLoading}
        setIsUpdating={setIsUpdating}
        canAddManually={canAddManually}
        userDefault={userDefault}
      />;
    } else if (networkStatus === statusIds.relationship) {
      return <CarrierNetworkRelationshipAction
        networkUserName={networkUserName}
        networkUserId={networkUserId}
        activeUser={activeUser}
        networkStatus={networkStatus}
        getNetworkStatus={getNetworkStatus}
        carrier={carrier}
        getCarrier={getCarrier}
        canUpdate={canUpdate}
        canRemove={canRemove}
        statusLabels={statusLabels}
        carrierNetworkId={carrierNetworkId}
        setIsLoading={setIsLoading}
        setIsUpdating={setIsUpdating}
        canAddManually={canAddManually}
        userDefault={userDefault}
      />;
    } else if (networkStatus === statusIds.open) {
      return <SecurityCheck 
        componentName="CarrierNetworkAddLead"
        action="Update"
      >
        <CarrierNetworkOpenAction
          networkUserName={networkUserName}
          networkUserId={networkUserId}
          activeUser={activeUser}
          networkStatus={networkStatus}
          getNetworkStatus={getNetworkStatus}
          carrier={carrier}
          getCarrier={getCarrier}
          canUpdate={canUpdate}
          canRemove={canRemove}
          statusLabels={statusLabels}
          carrierNetworkId={carrierNetworkId}
          setIsLoading={setIsLoading}
          setIsUpdating={setIsUpdating}
          canAddAsLead={canAddAsLead}
          canAddManually={canAddManually}
          userDefault={userDefault}
        />
      </SecurityCheck>;
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "end" }}>
      {getActionsComponent()}
    </Box>
  );
}

CarrierNetworkActions.propTypes = {
  networkStatus: PropTypes.string.isRequired,
  statusIds: PropTypes.object.isRequired,
  statusLabels: PropTypes.object.isRequired,
  canUpdate: PropTypes.bool,
  canRemove: PropTypes.bool,
  setIsLoading: PropTypes.func,
  getNetworkStatus: PropTypes.func.isRequired,
  carrier: PropTypes.object.isRequired,
  activeUser: PropTypes.object,
  networkUserId: PropTypes.string,
  carrierNetworkId: PropTypes.number,
  getCarrier: PropTypes.func.isRequired,
  setIsUpdating: PropTypes.func.isRequired,
  canAddAsLead: PropTypes.bool,
  networkUserName: PropTypes.string
};